import { render, staticRenderFns } from "./heart.vue?vue&type=template&id=e5d1b7b6&"
import script from "./heart.vue?vue&type=script&lang=js&"
export * from "./heart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports